export default[
    {
        path: '/medicamentos',
        //name: 'admin',
        component: () => import(/* webpackChunkName: "medicamentos" */'@/views/Medicamentos.vue'),
        meta: {
            requiresAuth: true,
            roles:['ROLE_PACIENTES'],
        },
        children:[
            {
                path:'/',
                name:'medsMain',
                component: () => import(/* webpackChunkName: "medsMain" */'@/views/medicamentos/MedsMenu.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_PACIENTES'],
                },
            },
            {
                path:'frio',
                name:'medsFrio',
                component: () => import(/* webpackChunkName: "medsFrio" */'@/views/medicamentos/Frio.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_PACIENTES'],
                },
            },
            {
                path:'cuadrobasico',
                name:'cuadroBasico',
                component: () => import(/* webpackChunkName: "cuadroBasico" */'@/views/medicamentos/CuadroBasico.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_PACIENTES'],
                },
            },
            {
                path:'aware',
                name:'araew',
                component: () => import(/* webpackChunkName: "cuadroBasico" */'@/views/medicamentos/MedicamentosAware.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_PACIENTES'],
                },
            },
        ],
    }
]